module.exports = __webpack_public_path__ + "img/築辰.f4fb416e.png";